import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import * as homeInitialState from '../initialState';
import {
  AbsolutePositioned,
  BackgroundContainer
} from '../../../components/Layout/AbsolutePositioned';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../components/Layout/Line';
import Logo from '../../../components/Logo';
import LineLink from '../../../components/LineLink';
import Timeline from '../../../components/Timeline';
import Title, { Highlight } from '../../../components/Title';

// Assets
import { brandColors, device, fixPoints } from '../../../styles/variables';
import microscope from '../../../assets/images/microscope.png';
import airship from '../../../assets/images/pages/home/airship.png';
import SealAnimation from '../../../components/SealAnimation';

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const OverlayContainer = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const mediaQuery = `${device.laptop} and ${fixPoints.oneMax}`;

const TimelinePositioned = AbsolutePositioned.extend`
  width: 100%;
  box-sizing: border-box;
  z-index: 22;
  height: 300px;
  top: 17%;

  @media ${device.tablet} {
    //transform: translate(-50%, -50%);
  }
  @media ${device.laptop} {
    top: 28%;
  }

  .featureTimeline {
    max-width: 1290px;
    margin: 0 auto;
    padding: 0 0 0 40px;

    @media ${mediaQuery} {
      padding: 0 0 0 22px;
    }

    @media ${fixPoints.oneMin} {
      margin: 0 auto;
      padding: 0 0 0 22px;
    }

    h2 {
      max-width: 571px;
      @media ${device.tablet} {
        max-width: 746px;
      }
      @media ${device.laptop} {
        max-width: 910px;
      }
    }
  }
`;

const LineLinksPosition = AbsolutePositioned.extend`
  width: 100%;
  box-sizing: border-box;

  .featureLineLinks {
    position: relative;
    width: 80%;
    pointer-events: all;
  }
`;

const LineLinksSplitScreenContent = SplitScreenContentHolder.extend`
  padding: 0 0 0 40px;
  @media ${device.laptop} {
    padding: 0 0 0 108px;
  }
`;

const ContentHolder = styled.div`
  position: relative;
  pointer-events: none;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
`;

const FeatureImage = styled.img`
  width: 100%;
  max-width: 319px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 30px;
`;

const SealContainer = styled.div`
  display: none;
  @media ${device.laptop} {
    margin-left: 60%;
    padding-top: 2%%;
    display: block;
  }
`;

class FeatureScreen extends React.PureComponent {
  constructor(props) {
    super(props);

    // need to set the store for home
    // place to set all the required elements
    // but for now it is just stored in the initialState.js file
    this.homeDetails = homeInitialState.default;
  }

  /* eslint-disabled no-param-reassign */
  featureScreenHover(item, otherItem) {
    otherItem.hovered = false;
    item.hovered = true;

    this.forceUpdate();
  }

  render() {
    const { featureScreen } = this.homeDetails.screens;

    return (
      <Screen className="feature-screen">
        {/* Feature Background */}
        <BackgroundContainer>
          <StyledSplitScreen
            backgroundColor={
              featureScreen.side1.hovered
                ? featureScreen.side1.background
                : featureScreen.side2.side1.background
            }
          />
          <StyledSplitScreen
            backgroundColor={
              featureScreen.side2.hovered
                ? featureScreen.side2.background
                : featureScreen.side1.side2.background
            }
          />
        </BackgroundContainer>

        {/* Content Container */}
        <ContentHolder>
          {/* logo */}
          <Logo />
          <SealContainer>
            <SealAnimation whiteseal />
          </SealContainer>
          {/* Timeline */}
          <TimelinePositioned>
            <Timeline className="featureTimeline" timelineId="homeTimeline1" automatic>
              <Title timelineStep="01" color={brandColors.white}>
                Research, design and craft <Highlight>of</Highlight> learning solutions
              </Title>
              <Title timelineStep="02" color={brandColors.white}>
                Deliverables to fulfil <Highlight>your</Highlight> vision and objectives
              </Title>
              <Title timelineStep="03" color={brandColors.white}>
                Global, European <Highlight>and</Highlight> UK client base
              </Title>
              <Title timelineStep="04" color={brandColors.white}>
                We&apos;re <Highlight>almost</Highlight> as old as the world wide web!
              </Title>
            </Timeline>
          </TimelinePositioned>
          {/* Links */}
          <LineLinksPosition bottom="7%" top="unset">
            <SplitScreen
              onMouseEnter={() => this.featureScreenHover(featureScreen.side1, featureScreen.side2)}
            >
              <LineLinksSplitScreenContent direction="right">
                <LineLink
                  className="featureLineLinks"
                  linkText="who are we?"
                  subtitle="read about us"
                  linkColor={
                    featureScreen.side1.hovered
                      ? featureScreen.side1.lineText
                      : featureScreen.side2.side1.lineText
                  }
                  route="/about-us"
                  lineTextWidth="220px"
                  lineAnimate
                  active
                  triggerAnimation={featureScreen.side1.hovered}
                  reverseAnimation={!featureScreen.side1.hovered}
                />
              </LineLinksSplitScreenContent>
            </SplitScreen>
            <SplitScreen
              onMouseEnter={() => this.featureScreenHover(featureScreen.side2, featureScreen.side1)}
            >
              <LineLinksSplitScreenContent direction="left">
                <LineLink
                  className="featureLineLinks"
                  linkText="show me examples"
                  subtitle="see case studies"
                  linkColor={
                    featureScreen.side2.hovered
                      ? featureScreen.side2.lineText
                      : featureScreen.side1.side2.lineText
                  }
                  lineTextWidth="220px"
                  lineAnimate
                  active
                  triggerAnimation={featureScreen.side2.hovered}
                  reverseAnimation={!featureScreen.side2.hovered}
                  linkOverlayType="case-studies"
                />
              </LineLinksSplitScreenContent>
            </SplitScreen>
          </LineLinksPosition>
        </ContentHolder>

        {/* Feature Overlay Container */}
        <OverlayContainer>
          <StyledSplitScreen
            onMouseEnter={() => this.featureScreenHover(featureScreen.side1, featureScreen.side2)}
          >
            {!featureScreen.side1.hovered ? <HorizontalLine /> : null}
            {!featureScreen.side1.hovered ? (
              <SplitScreenContentHolder direction="right">
                <DiagonalLine />
                <VerticalLine />
              </SplitScreenContentHolder>
            ) : (
              <SplitScreenContentHolder direction="right">
                <FeatureImage src={microscope} alt="Microscope" />
              </SplitScreenContentHolder>
            )}
          </StyledSplitScreen>
          <StyledSplitScreen
            onMouseEnter={() => this.featureScreenHover(featureScreen.side2, featureScreen.side1)}
          >
            {!featureScreen.side2.hovered ? <HorizontalLine /> : null}
            {!featureScreen.side2.hovered ? (
              <SplitScreenContentHolder>
                <DiagonalLine />
                <VerticalLine />
              </SplitScreenContentHolder>
            ) : (
              <SplitScreenContentHolder>
                <FeatureImage src={airship} alt="Airship" />
              </SplitScreenContentHolder>
            )}
          </StyledSplitScreen>
        </OverlayContainer>
      </Screen>
    );
  }
}

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/Home/screens/Feature.jsx